<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4hyzU8/Images/cover.jpg?1685327059746" alt="This image is the cover for the book Obsidian Sun, Obsidian Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Obsidian Sun, Obsidian Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Obsidian Series: Book One</i></b></p><p>Differences must be put aside when vengeance becomes all-consuming.</p> <p>Anan, a spellweaver of the Talac people, returns from a hunting trip to find his village decimated, his mate dead, and everyone else captured by Varas slavers. The sole survivor is Terja, a young man without the velvet that covers most Talac, marking him as a spellspinner. Since Talac magic requires both a weaver and a spinner, Anan and Terja must move beyond their ingrained mistrust. All that remains is revenge and a desperate plan to rescue their tribesmen before they are sold to Varas pleasure houses. A goal Anan and Terja are willing to die for.</p> <p>With the blessing of the Talac gods, they discover new and surprising ways to complement each other’s power. But as they race through terrain full of enemies and dangerous creatures to reach their people before they pass into Varas lands, they must take drastic steps to face the overwhelming odds against them. Understanding their connection might be their only hope.</p><p><img height="219" src="http://i28.photobucket.com/albums/c249/dreamspinnerpresssocial/Rainbow%20Award%20Runner%20Up_zpsmx2sx2qr.jpg" width="219"/><br/>2015 Rainbow Awards Best Gay Fantasy Runner-Up</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Keys
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?581faf98